<script setup lang="ts">
import background from '~/assets/images/backgrounds/to_interests.jpg';
import screenshots from '~/assets/screenshots/tasks/config?screenshots';

const getImage = useImage();
const { t } = useI18n();

const IMAGES = [
  {
    src: getImage(screenshots[621], { format: 'webp' }),
    alt: t('screenshots.0.alt'),
  },
  {
    src: getImage(screenshots[6], { format: 'webp' }),
    alt: t('screenshots.1.alt'),
  },
];
</script>

<template>
  <section class="pt-12 pb-16 p-section relative bg-black">
    <NuxtImg
      class="page-image-preview hidden md:block w-full h-full"
      :src="background"
      width="1000"
      height="1236"
      :alt="t('preview_alt')"
      sizes="lg:100vw xl:100vw xxl:100vw"
      format="avif"
      loading="lazy"
    />
    <div
      class="page-overflow-8 section-top-shadow section-bottom-shadow hidden md:block"
    />

    <h2
      data-show-on-visible
      class="lg:container text-2xl md:text-4xl text-800 relative z-2 text-center md:text-left mb-8"
    >
      {{ t('title') }}
    </h2>
    <div
      class="lg:container grid grid-cols-12 gap-6 md:gap-3 relative z-1"
    >
      <div
        class="col-span-12 md:col-span-5 lg:col-span-6 xl:col-span-5 md:py-3 relative"
      >
        <div class="-bottom-4 -top-20 extended-absolute-screen block md:hidden">
          <NuxtImg
            class="page-image-preview w-full h-full"
            :src="background"
            width="1000"
            height="1236"
            :alt="t('preview_alt')"
            sizes="xs:100vw sm:100vw md:100vw"
            format="avif"
            loading="lazy"
          />
          <div
            class="page-overflow-8 section-top-shadow section-bottom-shadow"
          />
        </div>

        <div
          data-show-on-visible
          class="text-700 text-lg xl:text-xl relative z-1 mb-5"
          style="border-radius: 6px"
        >
          {{ t('description') }}
          <ul class="mt-6 mb-8 pl-4 text-sm xl:text-lg !leading-6">
            <li class="mb-2">{{ t('rules.0') }}</li>
            <li class="mb-2">{{ t('rules.1') }}</li>
            <li class="mb-2">{{ t('rules.2') }}</li>
            <li>{{ t('rules.3') }}</li>
          </ul>
          <Button
            as="nuxt-link"
            to="/about-fants"
            rounded
            size="large"
            class="p-section"
          >
            {{ t('find_out_interests') }}
          </Button>
        </div>
      </div>
      <div
        data-show-on-visible='{ "delay": 150, "noDelayOnMobile": 768 }'
        class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-12 col-span-12 md:col-span-7 lg:col-span-6 xl:col-span-7 gap-4 relative z-1"
      >
        <div
          v-for="(image, index) in IMAGES"
          :key="image.src"
          class="xl:col-span-5"
          :class="{ 'xl:col-start-3': index === 0 }"
        >
          <div
            class="bg-surface-800 shadow-2 rounded-lg p-2 xl:p-3"
            style="border-radius: 6px"
          >
            <Image
              :src="image.src"
              :alt="image.alt"
              class="w-full !block aspect-screenshot"
              preview
              :preview-button-props="{ 'aria-label': t('zoom_image_button') }"
              :pt="{
                image: { class: 'w-full h-full object-cover', loading: 'lazy' },
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<i18n>
en:
  screenshots:
    - alt: Forfeits and tasks for sex
    - alt: Forfeits and tasks for sex
  preview_alt: Forfeits and tasks for sex
  title: Want to move from words to deeds?
  description: >
    If you already know what you want with your partner, or want to bring your fantasies to life, then move on to the game of erotic tasks.
    Choose the categories you are interested in and perform sexual tasks of varying degrees of intimacy: from talking and caressing to passionate hot sex!
  rules:
    - 'Choose the categories you are interested in: classic sex, oral, toys and much more;'
    - Receive tasks for you and your partner. Perform them and have fun together;
    - If you want more, then increase your level and receive increasingly vulgar tasks;
    - Enjoy the process and have fun as much as you want!
  find_out_interests: Sex tasks
  zoom_image_button: Enlarge image

ru:
  screenshots:
    - alt: Фанты и задания для секса
    - alt: Фанты и задания для секса
  preview_alt: Фанты и задания для секса
  title: Хотите перейти от слов к делу?
  description: >
    Если вы уже знаете, чего хотите с партнером, или желаете воплотить фантазии в жизнь, то переходите к игре в эротические задания.
    Выбирайте интересующие вас категории и выполняйте сексуальные задания разной степени близости: от разговоров и ласки до страстного горячего секса!
  rules:
    - 'Выбираете интересующие вас категории: классический секс, оральный, игрушки и многое другое;'
    - Получайте задания для вас и вашего партнера. Выполняйте их и получайте удовольствие вместе;
    - Если вам хочется большего, то повышайте уровень и получайте все более пошлые задания;
    - Наслаждайтесь процессом и получайте удовольствие сколько сами того захотите!
  find_out_interests: Секс задания
  zoom_image_button: Увеличить изображение

de:
  screenshots:
    - alt: Verluste und Aufgaben für Sex
    - alt: Verluste und Aufgaben für Sex
  preview_alt: Verluste und Aufgaben für Sex
  title: Möchten Sie den Worten Taten folgen lassen?
  description: >
    Wenn Sie bereits wissen, was Sie mit Ihrem Partner wollen oder Ihre Fantasien wahr werden lassen möchten, dann gehen Sie zu erotischen Aufgaben über.
    Wählen Sie die Kategorien aus, die Sie interessieren, und erledigen Sie sexuelle Aufgaben unterschiedlicher Intimität: von Gesprächen und Liebkosungen bis hin zu leidenschaftlichem, heißem Sex!
  rules:
    - 'Wählen Sie die Kategorien, die Sie interessieren: klassischer Sex, Oralsex, Spielzeug und vieles mehr;'
    - Erhalten Sie Aufgaben für Sie und Ihren Partner. Machen Sie sie und haben Sie gemeinsam Spaß;
    - Wenn Sie mehr wollen, erhöhen Sie das Level und erhalten Sie immer vulgärere Aufgaben.
    - Genießen Sie den Prozess und haben Sie so viel Spaß, wie Sie möchten!
  find_out_interests: Sexaufgaben
  zoom_image_button: Bild vergrößern

es:
  screenshots:
    - alt: Pérdidas y tareas por sexo.
    - alt: Pérdidas y tareas por sexo.
  preview_alt: Pérdidas y tareas por sexo
  title: ¿Quieres pasar de las palabras a la acción?
  description: >
    Si ya sabes lo que quieres con tu pareja, o quieres hacer realidad tus fantasías, pasa a jugar tareas eróticas.
    Selecciona las categorías que te interesen y completa tareas sexuales de distintos grados de intimidad: ¡desde conversaciones y caricias hasta sexo caliente y apasionado!
  rules:
    - 'Elige las categorías que te interesan: sexo clásico, oral, juguetes y mucho más;'
    - Recibe tareas para ti y tu pareja. Hazlos y diviértete juntos;
    - Si quieres más, sube de nivel y consigue tareas cada vez más vulgares;
    - ¡Disfruta del proceso y diviértete tanto como quieras!
  find_out_interests: Tareas sexuales
  zoom_image_button: Ampliar imagen

fr:
  screenshots:
    - alt: Forfaits et tâches pour le sexe
    - alt: Forfaits et tâches pour le sexe
  preview_alt: Forfaits et tâches pour le sexe
  title: Vous voulez passer des paroles aux actes ?
  description: >
    Si vous savez déjà ce que vous voulez avec votre partenaire ou si vous souhaitez réaliser vos fantasmes, passez aux tâches érotiques.
    Sélectionnez les catégories qui vous intéressent et accomplissez des tâches sexuelles de différents degrés d'intimité : des conversations et caresses au sexe torride passionné !
  rules:
    - 'Choisissez les catégories qui vous intéressent : sexe classique, oral, jouets et bien plus encore ;'
    - Recevez des tâches pour vous et votre partenaire. Faites-les et amusez-vous ensemble ;
    - Si vous en voulez plus, alors augmentez le niveau et obtenez des tâches de plus en plus vulgaires ;
    - Profitez du processus et amusez-vous autant que vous le souhaitez !
  find_out_interests: tâches sexuelles
  zoom_image_button: Agrandir l'image
</i18n>
